import { SKU } from "./engine";

/** The joining-kit SKU referenced by the renderer (mirrors `autoAddRules`). */
export const JOINING_KIT_SKU: SKU = "SKSFJ800P";
